export default __webpack_public_path__ + "static/media/column-blue-full-closed.313d45af.svg";